import * as validator from 'yup';

import emailSchema from './emailSchema';

const forgotPasswordSchema = validator.object({
  emailForgotPassword: emailSchema,
});

export default forgotPasswordSchema;
